
import * as THREE from 'three';
import { OrbitControls } from 'three/addons/controls/OrbitControls.js';
import { GLTFLoader } from 'three/addons/loaders/GLTFLoader.js';
import { GlslPipeline } from 'glsl-pipeline';

import shader_vert from "./glsl/main.vert";
import shader_frag from "./glsl/main.frag";

let W = window,
    D = document;

let pixelRatio = W.devicePixelRatio;

const canvas = document.getElementById('threejs');
const renderer = new THREE.WebGLRenderer( { canvas: canvas, antialias: true, alpha: true } );
renderer.setPixelRatio(pixelRatio);
// renderer.setSize(width, height);
let width = canvas.clientWidth;
let height = canvas.clientHeight;
renderer.setSize(width, height, false);
renderer.shadowMap.enabled = true;
// D.body.appendChild(renderer.domElement);

let uniforms = {
    u_tex0Resolution: { value: new THREE.Vector2() }
};

const tex0 = new THREE.TextureLoader().load("assets/cockatoo_00.png", (tex) => {
    uniforms.u_tex0Resolution.value.set(tex.image.width, tex.image.height);
});
tex0.wrapS = THREE.RepeatWrapping;
tex0.wrapT = THREE.RepeatWrapping;
uniforms.u_tex0 = { value: tex0 };

// GLSL Buffers
const glsl_pipeline = new GlslPipeline(renderer, uniforms);
glsl_pipeline.load(shader_frag, shader_vert);

// Camera
const camera = new THREE.PerspectiveCamera(45, width / height, 0.1, 100);
camera.position.z = 12;
camera.position.x = -10;
const controls = new OrbitControls(camera, renderer.domElement);
controls.update();

// Scene
const scene = new THREE.Scene();

// // Scene: IBL
glsl_pipeline.setCubemap("assets/studio_small_03_2k.hdr", scene);
// scene.environmentIntensity = 0.25;
// scene.backgroundIntensity = 0.75;

// Scene: Lights
// const light = new THREE.DirectionalLight(0xffffff, 1.0);
// light.position.set(0, 10, 8);
// light.lookAt(0, 0, 0);
// light.castShadow = true;
// light.shadow.mapSize.width = 1024;
// light.shadow.mapSize.height = 1024;
// light.shadow.camera.near = 0.1;
// light.shadow.camera.far = 20;
// scene.add(light);
// glsl_pipeline.setLight(light);

// Scene: Mesh
let model = null;
const gltfLoader = new GLTFLoader();
gltfLoader.load(
    'assets/001.glb',
    function ( gltf ) { 
        model = gltf.scene;
        const object = model;

        const box = new THREE.Box3().setFromObject(object);
        const center = box.getCenter(new THREE.Vector3());
        
        object.traverse( function ( child ) {
            if ( child.isMesh && child.name === "screen_surface") {
                child.material = glsl_pipeline.material;
                child.castShadow = true;
                child.receiveShadow = true;
            }
        } );

        object.position.sub(center);
        scene.add( object ); 
    },
    function ( xhr ) { console.log( ( xhr.loaded / xhr.total * 100 ) + '% loaded' ); },
    function ( error ) { console.log( 'An error happened' ); }
);

const draw = () => {
    if (scene.background) scene.background = null;

    if (model) {
        model.rotation.y = -window.scrollY * 0.001;
    }

    glsl_pipeline.renderScene(scene, camera);
    requestAnimationFrame(draw);
};

const resize = () => {
    width = canvas.clientWidth;
    height = canvas.clientHeight;
    pixelRatio = W.devicePixelRatio;

    renderer.setPixelRatio(pixelRatio);
    renderer.setSize(width, height, false);

    glsl_pipeline.setSize(width, height);

    camera.aspect = width / height;
    camera.updateProjectionMatrix();
};

W.addEventListener("resize", resize);
resize();
draw();
